import { render, staticRenderFns } from "./PasswordResetDone.vue?vue&type=template&id=4e1f4a66"
import script from "./PasswordResetDone.vue?vue&type=script&lang=js"
export * from "./PasswordResetDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports